import React from 'react';
import TextInput from '@adsk/alloy-react-text-input';
import { CustomAttribute } from '../../sdk/types/common/customAttribute';

export type NumericAttributeInputProps = {
  attribute: CustomAttribute;
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
  placeholder?: string;
  error?: boolean;
  ['data-testid']?: string;
};

/**
 * Layer A primitive: numeric variant of `TextAttributeInput`. Values are kept
 * as strings to match the existing model contract (custom attribute numeric
 * values are stored as strings, not numbers).
 */
export const NumericAttributeInput = ({
  attribute,
  value,
  onChange,
  disabled,
  placeholder,
  error,
  'data-testid': dataTestId,
}: NumericAttributeInputProps) => (
  <TextInput
    type={TextInput.TYPES.NUMBER}
    name={`custom-attr-${attribute.id}`}
    value={value}
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
    disabled={disabled}
    placeholder={placeholder}
    data-testid={dataTestId ?? `custom-attr-${attribute.id}`}
    error={!!error}
  />
);
